import { render, staticRenderFns } from "./content-page-header-image-panel.vue?vue&type=template&id=ad0c8e68&"
var script = {}
import style0 from "../../../assets/styles/panels/_ContentPageHeaderImagePanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports